import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import LoadingSpinner from '../Common/LoadingSpinner';

const WhatsAppCallback = () => {
    const location = useLocation();
    const handledRef = React.useRef(false);

    useEffect(() => {
        const handleCallback = async () => {
            if (handledRef.current) return;
            handledRef.current = true;

            // CRITICAL LOGGING: See exactly what Meta is sending
            console.log('🔗 [CALLBACK] FULL URL:', window.location.href);
            console.log('🔗 [CALLBACK] Search Params:', location.search);
            console.log('🔗 [CALLBACK] Hash Params:', location.hash);

            const getParam = (name) => {
                const searchParam = new URLSearchParams(location.search).get(name);
                if (searchParam) return searchParam;

                const hashParams = new URLSearchParams(location.hash.substring(1));
                return hashParams.get(name);
            };

            const code = getParam('code');
            const sessionInfoStr = getParam('session_info');

            // GREEDY: Meta sometimes passes these as top-level params
            const directWabaId = getParam('waba_id') || getParam('business_account_id') || getParam('account_id');
            const directPhoneId = getParam('phone_number_id') || getParam('phone_id');

            let extraData = {
                businessAccountId: directWabaId,
                phoneNumberId: directPhoneId
            };

            if (sessionInfoStr) {
                try {
                    const sessionInfo = JSON.parse(sessionInfoStr);
                    console.log('📦 [CALLBACK] Decoded session_info:', sessionInfo);

                    // Prioritize IDs from session_info if available
                    if (sessionInfo.waba_id) extraData.businessAccountId = sessionInfo.waba_id;
                    if (sessionInfo.phone_number_id) extraData.phoneNumberId = sessionInfo.phone_number_id;
                    if (sessionInfo.account_id && !extraData.businessAccountId) extraData.businessAccountId = sessionInfo.account_id;
                } catch (e) {
                    console.error('❌ [CALLBACK] Error parsing session_info:', e);
                }
            }

            console.log('🎯 [CALLBACK] Extraction Result:', { code: !!code, ...extraData });

            if (!code) {
                console.error('❌ [CALLBACK] No code found in URL');
                if (window.opener) {
                    window.opener.postMessage({
                        type: 'WA_CONNECTION_ERROR',
                        message: 'No authorization code found in Meta redirect.'
                    }, window.location.origin);
                    setTimeout(() => window.close(), 2000);
                }
                return;
            }

            if (window.opener) {
                console.log('📤 [CALLBACK] Posting message to opener window...');
                window.opener.postMessage({
                    type: 'WA_CONNECTION_SUCCESS',
                    code: code,
                    ...extraData
                }, window.location.origin);

                // Delay closing to ensure transmission
                setTimeout(() => {
                    console.log('👋 [CALLBACK] Closing window.');
                    window.close();
                }, 1000);
            } else {
                console.error('❌ [CALLBACK] No opener window found! User might have refreshed or closed the main tab.');
            }
        };

        handleCallback();
    }, [location]);

    return (
        <div className="callback-loading-container" style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            textAlign: 'center',
            backgroundColor: '#f9f9f9'
        }}>
            <LoadingSpinner size="large" />
            <h2 style={{ marginTop: '20px', color: '#128C7E' }}>Connecting to Meta...</h2>
            <p style={{ color: '#666' }}>Capturing your business account verification.</p>
            <div style={{ marginTop: '10px', fontSize: '12px', color: '#999' }}>
                Please stay on this page.
            </div>
        </div>
    );
};

export default WhatsAppCallback;
